const UI_VERSION = {
    NEW: "new",
    OLD: "old",
};

export const CLOUD_PROVIDERS = Object.freeze(["azure", "aws", "gcp", "kubernetes"]);

// Import provider icons so bundler can hash and optimize them centrally
import azureIcon from "./img/azu.svg";
import awsIcon from "./img/aws.svg";
import gcpIcon from "./img/gcp.svg";
import k8sIcon from "./img/kubernetes.svg";

// Map of provider -> icon asset (single source of truth)
export const PROVIDER_ICONS = Object.freeze({
    azure: azureIcon,
    gcp: gcpIcon,
    aws: awsIcon,
    kubernetes: k8sIcon,
});

// Central AWS region list (single source of truth)
export const AWS_REGIONS = Object.freeze([
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2",
    "ap-south-1",
    "ap-northeast-3",
    "ap-northeast-2",
    "ap-southeast-1",
    "ap-southeast-2",
    "ap-northeast-1",
    "ca-central-1",
    "eu-central-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "eu-north-1",
    "sa-east-1",
    "af-south-1",
    "ap-east-1",
    "ap-south-2",
    "ap-southeast-3",
    "ap-southeast-4",
    "ca-west-1",
    "eu-south-1",
    "eu-south-2",
    "eu-central-2",
    "me-south-1",
    "me-central-1",
    "il-central-1"
]);

/**
 * AppFactor custom theme for JsonEditor component (json-edit-react)
 * Used across the application for consistent JSON editing styling
 */
export const APPFACTOR_JSON_EDITOR_THEME1 = Object.freeze({
    displayName: 'AppfactorTheme',
    styles: {
        container: {
            fontFamily: 'Inter',
            fontSize: 12,
            backgroundColor: 'transparent',
        },
        property: '#FFFFFFEE',
        bracket: '#FFFFFF99',
        itemCount: '#8B949E',
        string: '#A5D6FF',
        number: '#D2A8FF',
        boolean: { color: '#FF7B72', fontSize: '90%', fontWeight: 'bold' },
        null: 'green',
        iconCollection: '#D2A8FF',
        iconEdit: '#D2A8FF',
        iconDelete: 'rgb(203, 75, 22)',
        iconAdd: 'rgb(203, 75, 22)',
        iconCopy: '#A5D6FF',
        iconOk: '#56d364',
        iconCancel: 'rgb(203, 75, 22)',
    },
});

const colorRed = 'rgb(223, 29, 33)';
export const APPFACTOR_JSON_EDITOR_THEME_ICONS = {
    copy:
    <svg 
    focusable="false"
    aria-hidden="true"
    width="16"
    height="16"
    viewBox="0 0 24 24" >
        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor"/>
    </svg>,
    chevron: <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
        <g
            style={{
                transformOrigin: "center",
                transform: "scale(2)"
            }}
            opacity="0.42" clipPath="url(#clp)">
            <path d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z" fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clp">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
}

export const APPFACTOR_JSON_EDITOR_THEME = {
    displayName: 'AppfactorTheme',
    styles: {
        container: {
            fontFamily: 'Inter',
            fontSize: 12,
            backgroundColor: 'transparent',
        },
        property: '#FFF',
        bracket: '#FFF',
        itemCount: '#8B949E',
        string: '#87AFFF',
        number: '#A4D6FF',
        boolean: { color: '#FF7B72', fontSize: '90%', fontWeight: 'bold' },
        null: 'green',
        iconCollection: '#D2A8FF',
        iconEdit: '#D2A8FF',
        iconAccordion: '#FFF',
        iconCollapse: '#FFF',
        iconDelete: colorRed,
        iconAdd: colorRed,
        iconCopy: '#A5D6FF',
        iconOk: '#56d364',
        iconCancel: colorRed,
    },
};


export const APPFACTOR_JSON_EDITOR_THEME_LIGHT = Object.freeze({
    displayName: 'AppfactorThemeLight',
    styles: {
        container: {
            fontFamily: 'Inter',
            fontSize: 12,
            backgroundColor: 'transparent',
        },
        property: '#24292f',
        bracket: '#57606a',
        itemCount: '#57606a',
        string: '#0a3069',
        number: '#8250df',
        boolean: { color: '#cf222e', fontSize: '90%', fontWeight: 'bold' },
        null: '#1a7f37',
        iconCollection: '#8250df',
        iconEdit: '#8250df',
        iconDelete: colorRed,
        iconAdd: colorRed,
        iconCopy: '#0a3069',
        iconOk: '#1a7f37',
        iconCancel: colorRed,
    },
});

export default UI_VERSION;
